const possibleLower = "abcdefghijklmnopqrstuvwxyz";
const possibleUpper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const possibleSpecial = "!@$%*&#";
const possibleNumber = "0123456789";

export default function() {
  let randomPassword = "";
  for (let i = 0; i < 37; i += 1) {
    randomPassword += possibleLower.charAt(
      Math.floor(Math.random() * possibleLower.length)
    );
  }
  randomPassword += possibleUpper.charAt(
    Math.floor(Math.random() * possibleUpper.length)
  );
  randomPassword += possibleSpecial.charAt(
    Math.floor(Math.random() * possibleSpecial.length)
  );
  randomPassword += possibleNumber.charAt(
    Math.floor(Math.random() * possibleNumber.length)
  );
  return randomPassword;
}
